/**
 * T15: PATCH_CABLE info formatting helper.
 * Pure function - testable without React.
 */

export interface PatchCableInfo {
  from: string
  to: string
  cable: string
  fromPortMissing: boolean
  toPortMissing: boolean
}

export function formatPatchCableInfo(meta?: Record<string, unknown>): PatchCableInfo {
  // String() coercion: meta values are unknown in strict TS; converts to string | null for template use
  const fromEquip = meta?.from_equipment != null ? String(meta.from_equipment) : null
  const fromPort  = meta?.from_port  != null ? String(meta.from_port) : null
  const toEquip   = meta?.to_equipment != null ? String(meta.to_equipment) : null
  const toPort    = meta?.to_port    != null ? String(meta.to_port) : null
  const cable     = meta?.cable_type != null ? String(meta.cable_type) : null
  const fromPortMissing = fromPort === null
  const toPortMissing   = toPort === null
  return {
    from:  `${fromEquip ?? 'не указано'} / ${fromPort ?? '⚠️ порт не указан'}`,
    to:    `${toEquip ?? 'не указано'} / ${toPort ?? '⚠️ порт не указан'}`,
    cable: cable ?? 'тип не указан',
    fromPortMissing,
    toPortMissing,
  }
}